module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABOklEQVR42mNgoBR8r9FxoAQz/K/R/n8s2/T/UTLwP6BesAHadgFk4V9VOggDFsRb/Qex2yLswXxTB9//f6q0wWKBHh5gsUx/FzB/V4YZpgG5gRDJnekQyTQ/VzAfhJvDIYbOibcB8zsj7TENsHb2AUu+KdUD82fE2fx/V677/1qB4f+taeZgsXO5xmA1YV7umAaA8N0iQ7ACT3ev/6dyTP7vBTp1UaL1/+el+v8NHfyAGrT/f63U+a9n74fdgFVJlmADmsId/n8HKuyKsv+fH+QMFqsKcfoPiTET7IEIwuVQRXcLDcB0hLf7f1uo12BiU2JtcRvg4uoND7hvQBfo2/mDxe8VGcDFE/3ccBsAws9L9MEKTyI5dXUyxGu/q7X/GwOjF68BJCekPxWab38B8c8KLZIxSC/DgAMA8XzCFn1QByMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/App/img/web.png
// module id = 625
// module chunks = 0